import SaleModel from "../data/model/Sale";
import ReceiptTemplate from "../data/model/ReceiptTemplate";
import { Sale } from "@towersystems/roam-common/lib/generated-types";
import { OnPrintReceiptOptions, UseReceiptsControllerResponse } from "./types";
import { usePrint } from "../print";

export interface UsePrintReceiptProps {
  controller: UseReceiptsControllerResponse;
}

export const usePrintReceipt = ({ controller }: UsePrintReceiptProps) => {
  const { print } = usePrint();
  const { generateReceiptHTML } = controller;

  const handleOnPrintReceipt = async (
    sale: Sale | SaleModel,
    receiptTemplate: ReceiptTemplate,
    options?: OnPrintReceiptOptions
  ) => {
    const html = await generateReceiptHTML(sale, receiptTemplate);
    return print(html, options);
  };

  return {
    handleOnPrintReceipt,
  };
};
